import { render } from "./BreathingExercises.vue?vue&type=template&id=bd4aaab4&scoped=true"
import script from "./BreathingExercises.vue?vue&type=script&lang=js"
export * from "./BreathingExercises.vue?vue&type=script&lang=js"

import "./BreathingExercises.vue?vue&type=style&index=0&id=bd4aaab4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bd4aaab4"]])

export default __exports__